import { render, staticRenderFns } from "./TalkPoll.vue?vue&type=template&id=6ada85f7&scoped=true&"
import script from "./TalkPoll.vue?vue&type=script&lang=ts&"
export * from "./TalkPoll.vue?vue&type=script&lang=ts&"
import style0 from "./TalkPoll.vue?vue&type=style&index=0&id=6ada85f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada85f7",
  null
  
)

export default component.exports